module.exports = __webpack_public_path__ + "static/media/user-info.db803268.jpg";